// extracted by extract-css-chunks-webpack-plugin
module.exports = {"item":"item_RlKzP","title":"title_c-+FD","content":"content_6FeLC","intro":"intro_7gwZ4","contact":"contact_wCGN3","contact_list":"contact_list_QIKKW"};